export default (badges, priorityMeta, type) => {
  if (!badges || !priorityMeta || !badges.length) return {}

  const priority = {
    product: priorityMeta.BADGE_PRODUCT[0],
    value: priorityMeta.BADGE_VALUE[0],
    delivery: priorityMeta.BADGE_DELIVERY[0]
  }
  const byPriority = badge => badge.id === priority[type]
  const badgeFound = badges.find(byPriority)
  return badgeFound || {}
}
